// Module
var code = `<div class="modal fade" tabindex="-1" role="dialog" data-bind="showModal: show">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-bind="click: clear">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" data-bind="label: 'cc_P_WARNING_TITLE'"></h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <p class="col-sm-12" data-bind="label: 'cc_P_NO_LINES_SELECTED'"></p>
                    <p class="col-sm-12" data-bind="label: 'cc_P_ARE_YOU_SURE_TO_CONTINUE'"></p>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" data-dismiss="modal" data-bind="click: continue, label: 'cc_P_CONTINUE_COMPL_CREATE'"></button>
                <button type="button" class="btn btn-default" data-dismiss="modal" data-bind="click: clear, label: 'cc_Close'"></button>
            </div>
        </div>
    </div>
</div>`;
// Exports
module.exports = code;